module.exports = __webpack_public_path__ + "static/img/home_case_bg_zh.9c3e0e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_bg_zh.png
// module id = QTV/
// module chunks = 34